import { startsWith } from "@/util/StringUtils"
import { hexToBase64, base64ToHex } from "@/util/security/HexConvertUtil"
import { sm2 } from "sm-crypto"

const cipherMode = 1 // 1 - C1C3C2，0 - C1C2C3，默认为1。 国密标准 GB/T 32918.2—2016 规定 SM2 密文应以 ASN.1 结构封装（C1+C3+C2）

export function encrypt(message: string): string {
  const publicKey = (window as any).eightcatty.encryptPublicKey
  return encryptToHex(message, publicKey)
}

export function encryptToHex(message: string, publicKey: string): string {
  if (message === "") {
    return ""
  }
  let result = sm2.doEncrypt(message, publicKey, cipherMode)
  //GM/T 0003.4-2012 规范要求密文带前缀 04
  if (!startsWith(result, "04")) {
    result = "04" + result
  }
  return result
}

export function decryptFromHex(encryptedData: string, privateKey: string): string {
  if (encryptedData === "") {
    return ""
  }
  let data = encryptedData
  //GM/T 0003.4-2012 规范要求密文带前缀 04，但sm-crypto内部会自动加上04前缀，故在此去掉04前缀
  if (startsWith(encryptedData, "04")) {
    data = encryptedData.slice(2)
  }
  return sm2.doDecrypt(data, privateKey, cipherMode)
}

export function encryptToBase64(message: string, publicKey: string): string {
  return hexToBase64(encryptToHex(message, publicKey))
}

export function decryptFromBase64(encryptedData: string, privateKey: string): string {
  return decryptFromHex(base64ToHex(encryptedData), privateKey)
}

export function generateKeyPair() {
  const keyPair = sm2.generateKeyPairHex()
  return {
    publicKey: keyPair.publicKey,
    privateKey: keyPair.privateKey,
  }
}

/** 校验 SM2 公钥是否有效。SM2 非压缩公钥格式：04 + 128 位十六进制字符 */
export function validatePublicKey(publicKey: string): boolean {
  if (!publicKey || publicKey.trim() === "") {
    return false
  }
  const key = publicKey.trim()
  // 格式校验：04 前缀 + 128 位十六进制字符
  const hexPattern = /^04[0-9a-fA-F]{128}$/
  if (!hexPattern.test(key)) {
    return false
  }
  try {
    // 试加密一小段文本，确认公钥能正确用于 SM2 加密
    sm2.doEncrypt("test", key, cipherMode)
    return true
  } catch {
    return false
  }
}
